import { useEffect, useState } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import PWAInstallModal from "./PWAInstallModal";

import { usePWAInstall } from "hooks/usePWAInstall";

const PWAInstallPrompt = () => {
  const { t } = useTranslation();
  const [promptVisible, setPromptVisible] = useState(false);
  const {
    installPWA,
    showIOSInstallCard,
    closeIOSInstructions,
    setPromptShown,
    shouldShowPrompt,
  } = usePWAInstall();

  useEffect(() => {
    if (shouldShowPrompt) {
      setPromptVisible(true);
    }
  }, [shouldShowPrompt]);

  const event_id = window.location.pathname.split("/").pop();

  // if event_id is not there, return null
  if (!event_id) {
    return null;
  }

  // If the prompt is already shown, return null
  if (!promptVisible) return null;

  const handleInstall = async () => {
    const result = await installPWA();
    if (result.success) {
      setPromptVisible(false);
    }
  };

  const handleCloseInstallPrompt = () => {
    setPromptVisible(false);
    setPromptShown(true);
  };

  const handleIOSModalClose = () => {
    closeIOSInstructions();
    setPromptVisible(false); // Also close the main prompt when iOS modal closes
  };

  return (
    <div
      className="position-fixed gallery-modal"
      style={{
        zIndex: 999,
        top: "60px",
        right: "20px",
        maxWidth: "300px",
      }}
    >
      <Card className="shadow-lg border-0" style={{ borderRadius: "16px" }}>
        <CardBody className="p-4">
          <div className="text-center mb-3">
            <h5 className="fw-bold mb-2 text-start">
              {t("Install as App, Get the full experience!")}
            </h5>
          </div>

          <Row className="g-2">
            <Col>
              <button
                className="btn btn-gallery-primary btn-rounded-2 mt-2 w-100 fw-bold"
                onClick={handleInstall}
                style={{ borderRadius: "8px" }}
              >
                <span className="mdi mdi-download me-2"></span>
                {t("Install App")}
              </button>
            </Col>
            <Col xs="auto">
              <button
                className="btn btn-gallery-outline-primary px-3 btn-rounded-2 mt-2"
                onClick={handleCloseInstallPrompt}
                style={{ borderRadius: "8px" }}
              >
                <span className="mdi mdi-close"></span>
              </button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* iOS Install Instructions Modal */}
      <PWAInstallModal
        isOpen={showIOSInstallCard}
        toggle={handleIOSModalClose}
        onClose={handleIOSModalClose}
      />
    </div>
  );
};

export default PWAInstallPrompt;
